import { Link } from 'react-router';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  color: #379683;
  font-family: inherit;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
`;

export default StyledLink;
